jQuery(document).ready(function ($) {
	var breakpoint_small = 0;
	var breakpoint_medium = 640;
	var breakpoint_large = 1024;
	var breakpoint_xlarge = 1200;
	var breakpoint_xxlarge = 1440;

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//											FACTS & FIGURES
	/////////////////////////////////////////////////////////////////////////////////////////////////

	// facts-figures-01
	// http://aishek.github.io/jquery-animateNumber/
	$('section.facts-figures-01 [data-number]').each(function () {
		var animate_number = String($(this).data('number'));
		var comma_separator_number_step = $.animateNumber.numberStepFactories.separator('.');

		// If the number has a , (decimal) also animate the decimals
		if (animate_number.indexOf(",") !== -1) {
			var number_parts = animate_number.split(",");
			var decimal_places = number_parts[1].length;

			var decimal_factor = decimal_places === 0 ? 1 : Math.pow(10, decimal_places);

			// Replace , for .
			animate_number = parseInt(animate_number.replace(",", ".") * decimal_factor);

			$(this).animateNumber({
				number: animate_number,
				easing: 'easeOutQuad',
				numberStep: function (now, tween) {
					var floored_number = Math.floor(now) / decimal_factor;
					var target = $(tween.elem);

					if (decimal_places > 0) {
						// force decimal places even if they are 0
						floored_number = floored_number.toFixed(decimal_places);

						// replace '.' separator with ','
						floored_number = floored_number.toString().replace('.', ',');
					}

					target.text(floored_number);
				}
			},
				3000);
		}
		else {
			// animate non-decimal numbers. Use dot . for 1000-separator for large numbers
			$(this).animateNumber({
				number: animate_number,
				easing: 'easeOutQuad',
				numberStep: comma_separator_number_step
			},
				3000);
		}
	});

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//											GOOGLE MAPS
	/////////////////////////////////////////////////////////////////////////////////////////////////

	// For all google maps:

	// Removes the invisible layer on the Google Map on click
	$('.google-map-overlay').on('click', function () {
		$(this).removeClass('google-map-overlay');
	});

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//											TESTIMONIALS
	/////////////////////////////////////////////////////////////////////////////////////////////////

	// testimonials-01
	// Create a slider from Dynamic Content Columns, only if there are more than 3 columns
	//	if (jQuery(".testimonial-01 .testimonials .testimonial").length > 2)
	//	{
	//		jQuery(".testimonial-01 .testimonials").slick({
	//			infinite: false,
	//			slidesToShow: 1,
	//			slidesToScroll: 1
	//		});
	//	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//												SLIDERS
	/////////////////////////////////////////////////////////////////////////////////////////////////

	// Create a slider from div.lite-slide elements, only if there are more than 1 items
	if (jQuery(".lite-slider .lite-slide").length > 1) {
		jQuery(".lite-slider").each(function () {
			// Default
			var slides_to_show = 1;
			var slides_to_show_small = 1;
			var slides_to_show_medium = 3;
			var slides_to_scroll = 1;

			// Check if there is data-attribute set
			if (jQuery(this).data('slides-to-show')) {
				slides_to_show = parseInt(jQuery(this).data('slides-to-show'));
			}

			// Check if there is data-attribute set
			if (jQuery(this).data('slides-to-show-small')) {
				slides_to_show_small = parseInt(jQuery(this).data('slides-to-show-small'));
			}

			// Check if there is data-attribute set
			if (jQuery(this).data('slides-to-scroll')) {
				slides_to_scroll = parseInt(jQuery(this).data('slides-to-scroll'));
			}

			var config = {
				infinite: false,
				slidesToShow: slides_to_show,
				slidesToScroll: slides_to_scroll,
				dots: true,
				adaptiveHeight: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: slides_to_show_medium,
							dots: true
						}
					},
					{
						breakpoint: 640,
						settings: {
							slidesToShow: slides_to_show_small,
                            arrows: false,
                            centerMode: true
						}
					}
				]
			};

			jQuery(this).not('.slick-initialized').slick(config);
		});
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//										HEADER-03 IMAGES
	/////////////////////////////////////////////////////////////////////////////////////////////////

	if (jQuery(".header-03 .header-images .header-img").length > 1) {
		$('.header-03 .header-images').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 4000
		});
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//										HEADER-04 IMAGES
	/////////////////////////////////////////////////////////////////////////////////////////////////

	if (jQuery(".header-04 .header-images .header-img").length > 1) {
		$('.header-04 .header-images').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 4000
		});
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//									VIDEO-HEADER-01 BG VIDEO
	/////////////////////////////////////////////////////////////////////////////////////////////////


	// jQuery is required to run this code
	scaleVideoContainer();

	initBannerVideoSize('.coverr-video-container video');

	$(window).on('resize', function () {
		scaleVideoContainer();
		scaleBannerVideoSize('.coverr-video-container video');
	});
});

function scaleVideoContainer() {
	var height = $(window).height() + 5;
	var unitHeight = parseInt(height) + 'px';
	$('.homepage-hero-module').css('height', unitHeight);
}

function initBannerVideoSize(element) {
	$(element).each(function () {
		$(this).data('height', $(this).height());
		$(this).data('width', $(this).width());
	});

	scaleBannerVideoSize(element);
}

function scaleBannerVideoSize(element) {

	var windowWidth = $(window).width(),
		windowHeight = $(window).height() + 5,
		videoWidth,
		videoHeight;

	$(element).each(function () {
		var videoAspectRatio = $(this).data('height') / $(this).data('width');

		$(this).width(windowWidth);

		if (windowWidth < 1000) {
			videoHeight = windowHeight;
			videoWidth = videoHeight / videoAspectRatio;
			$(this).css({ 'margin-top': 0, 'margin-left': -(videoWidth - windowWidth) / 2 + 'px' });

			$(this).width(videoWidth).height(videoHeight);
		}

		$('.homepage-hero-module .coverr-video-container video').addClass('fadeIn animated');

	});
}
